/**
 * SOL Balance Location Badge Component
 *
 * Displays a small badge indicating where SOL is located:
 * - "Wallet" for SOL in user's connected wallet
 * - "PDA" for SOL in the application's PDA (prize pool, locked rewards, etc.)
 * - "Total" for combined balances
 */

interface SolBalanceBadgeProps {
  location: 'wallet' | 'pda' | 'total';
  className?: string;
}

export function SolBalanceBadge({ location, className = '' }: SolBalanceBadgeProps) {
  const config = {
    wallet: {
      label: 'Wallet',
      color: '#51E4F8', // Cyan
      bgColor: 'rgba(81, 228, 248, 0.15)',
    },
    pda: {
      label: 'Junk Fun',
      color: '#FEBB01', // Gold
      bgColor: 'rgba(254, 187, 1, 0.15)',
    },
    total: {
      label: 'Total',
      color: '#FFFFFF',
      bgColor: 'rgba(255, 255, 255, 0.1)',
    },
  };

  const { label, color, bgColor } = config[location];

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs ${className}`}
      style={{
        fontFamily: 'Outfit, sans-serif',
        fontWeight: 600,
        color,
        backgroundColor: bgColor,
        border: `1px solid ${color}40`,
      }}
    >
      {label}
    </span>
  );
}
